import { RuleResult } from 'types/DeclarationP5'
import { excludeDeleted, hasText } from 'shared/lib/common-util'
import { TransportEquipment } from '../../common/types'

const C0670Validator = {
  validateGoodsReferenceRequirement: ({
    transportEquipments,
  }: {
    transportEquipments?: TransportEquipment[]
  }): RuleResult => {
    const equipment = transportEquipments?.filter(excludeDeleted) ?? []
    if (equipment.length === 1 && hasText(equipment.at(0)?.containerIdentificationNumber)) {
      return 'OPTIONAL'
    }
    return 'REQUIRED'
  },
} as const

export default C0670Validator
